export default __webpack_public_path__ + "static/media/support.6f28b685.svg";